import React from "react";
import styled from "styled-components";

const Element = styled.div`
  width: 100%;
  border-bottom: 1px solid #e96159;
  background: #f5f5f5;
`;

const ElementInverted = styled.div`
  width: 100%;
  border-bottom: 1px solid #ffffff;
  background: #e96159;
`;

const Holder = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  padding: 16px;
`;

const Logo = styled.img`
  width: 100%;
`;
export default function Header({ inverted }) {
  return inverted ? (
    <ElementInverted>
      <Holder>
        <Logo src="/images/logo-white.svg" alt="Logo" />
      </Holder>
    </ElementInverted>
  ) : (
    <Element>
      <Holder>
        <Logo src="/images/logo.svg" alt="Logo" />
      </Holder>
    </Element>
  );
}
